import { removeFromStatus } from './removeFromStatus';
import { type BoardTask } from '../../../../../common/types/task';
import { type BoardTasksState } from '../tasksSlice';
import { insertSorted } from './insertSorted';

// Применение к задаче всех переданных изменений, включая изменение статуса (с переносом в нужную колонку) и приоритета (с вычислением и вставкой в новую позицию)
export const update = (state: BoardTasksState, id: number, patch: Partial<BoardTask>) => {
  const existing = state.byId[id];

  if (!existing) return;

  // Если изменился статус - переносим из колонки в колонку
  const prevStatus = existing.status;
  const nextStatus = patch.status ?? prevStatus;

  if (prevStatus !== nextStatus) {
    removeFromStatus(state.idsByStatus, prevStatus, id);
    insertSorted(state, { ...existing, ...patch });
  }

  // Если изменился приоритет - передвигаем задачу на новую позицию
  const prevPriority = existing.priority;
  const nextPriority = patch.priority ?? prevPriority;

  if (prevPriority !== nextPriority) {
    // Используем уже новые данные для корректного вычисления текущей колонки и новой позиции
    removeFromStatus(state.idsByStatus, nextStatus, id);
    insertSorted(state, { ...existing, ...patch });
  }

  // Если изменился gold статус - пересчитываем позицию
  const prevGoldStatus = existing.isGold;
  const nextGoldStatus = patch.isGold;

  if (prevGoldStatus !== nextGoldStatus) {
    removeFromStatus(state.idsByStatus, nextStatus, id);
    insertSorted(state, { ...existing, ...patch });
  }

  Object.assign(existing, patch);
};
